import { ModalApi } from "components/modal/Modal";
import OnboardingModal from "components/modal/OnboardingModal";
import Button, { ButtonLevel, ButtonSize } from "components/ui/Button";
import UILabel from "components/ui/UILabel";
import { useRef } from "react";
import * as Styled from "./styled";

const EwaDirectTile = () => {
  const onboardingModal = useRef<ModalApi>(null);

  const onClickGetStarted = async () => {
    onboardingModal.current?.show();
  };

  const onOnboardingSuccess = () => {
    window.location.href = "/dashboard";
  };

  return (
    <>
      <Styled.Wrapper>
        <Styled.InfoContainer>
          <Styled.Info>
            <UILabel.Medium bold>
              Start accessing your pay as you earn it.
            </UILabel.Medium>

            <UILabel.Small>Just verify your income to start.</UILabel.Small>

            <Styled.Actions>
              <Button
                size={ButtonSize.sm}
                level={ButtonLevel.secondary}
                onClick={onClickGetStarted}
              >
                Get Started
              </Button>
            </Styled.Actions>
          </Styled.Info>
        </Styled.InfoContainer>
      </Styled.Wrapper>

      <OnboardingModal ref={onboardingModal} onSuccess={onOnboardingSuccess} />
    </>
  );
};

export default EwaDirectTile;
